class ShowMoreList extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.visibleItems = 4;
    this.isExpanded = false;
  }

  connectedCallback() {
    const items = this.getAttribute("items");
    this.items = JSON.parse(items);
    this.items = this.items.effects;

    this.render();
  }

  toggleItemsVisibility() {
    this.isExpanded = !this.isExpanded;
    this.visibleItems = this.visibleItems === 4 ? this.items.length : 4;
    this.render();
  }

  render() {
    const buttonText = this.isExpanded ? "Arată mai puțin" : "Arată mai mult";
    const showFadeOverlay = this.items.length > 4 && !this.isExpanded;

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: relative;
          display: block;
        }
        .list-wrapper {
          position: relative;
          max-height: ${
            this.isExpanded ? "none" : "600px"
          }; /* Adjust as needed */
          overflow: hidden;
        }
        .fade-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 150px; /* Adjust to match design */
          background: linear-gradient(to bottom, transparent, white);
          display: ${showFadeOverlay ? "block" : "none"};
        }
        .product-effects-list {
          padding: 0;
          -moz-column-count: 2;
          column-count: 2;
          -moz-column-gap: 32px;
          column-gap: 32px;
          margin-top: 32px;
          list-style: none;
        }
        
        @media (max-width: 991px) {
          .product-effects-list {
            padding: 0;
            -moz-column-count: 1;
            column-count: 1;
            -moz-column-gap: 32px;
            column-gap: 32px;
            margin-top: 32px;
            list-style: none;
          }
        }
        
        .product-effects-list li {
          display: inline-block;
          margin-bottom: 16px;
          transition: all 0.3s ease;
        }
        
        .effect-title {
          font-size: 20px;
          margin: 0;
        }
        
        .effect-description {
          font-size: 16px;
          line-height: 26px !important;
        }
        
        .toggle-button {
          color: gray;
          cursor: pointer;
        }
      </style>
      <div class="list-wrapper">
      <ul class="product-effects-list">
        ${this.items
          .slice(0, this.visibleItems)
          .map(
            (item) => `
          <li>
            <h3 class="effect-title">${item.title}</h3>
            <p class="effect-description">${item.description}</p>
          </li>`
          )
          .join("")}
      </ul>
      <div class="fade-overlay"></div>
      </div>
      <span class="toggle-button">${buttonText}</span>
    `;

    const toggleButton = this.shadowRoot.querySelector(".toggle-button");

    if (toggleButton) {
      toggleButton.addEventListener("click", () =>
        this.toggleItemsVisibility()
      );
    }
  }
}

customElements.define("show-more-list", ShowMoreList);